const styles = {
  linkButtonTooltip: { display: 'flex', alignItems: 'center' },
  linkButton: { mr: 1 },
}

export default styles
